import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Alert
} from "reactstrap";
import { ListaLaboratorio } from "./ListaLaboratorio";
import { Link } from "react-router-dom";
import { DatosSesion } from "../../../Components/Common/DatosSesion";
  
const LaboratorioListar = () => {
  document.title = "Lista de Laboratorios | Farme";
  const perfil = DatosSesion("perfil");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              {perfil === "Administrador" ||
              perfil === "Farmacia" ||
              perfil === "MyHealth" ? (
                <>
                  <Card>
                    <CardHeader className="border-0">
                      <div className="d-md-flex align-items-center">
                        <h5 className="card-title mb-3 mb-md-0 flex-grow-1">
                          Laboratorios
                        </h5>
                        <div className="flex-shrink-0">
                          <div className="d-flex gap-1 flex-wrap">
                            <Link to="/laboratorios/crear">
                              <Button
                                color="success"
                                type="button"
                                className="add-btn"
                                data-bs-toggle="modal"
                                id="create-btn"
                                data-bs-target="#showModal"
                              >
                                <i className="ri-add-line align-bottom me-1"></i>{" "}
                                Crear Laboratorio
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <ListaLaboratorio />
                    </CardBody>
                  </Card>
                </>
              ) : (
                <Alert color="danger">
                  No tienes permisos para ver esta página.
                </Alert>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LaboratorioListar;
